/**
 * Renders the shortcuts section on the home page with 4 ShortcutItem components
*/
import React from "react";
import ShortcutsItem from "./ShortcutsItem";

const ShortcutsMain = () => {
    return (
        <div className="relative w-full dark:mb-2 dark:mt-1 dark:icons1:mt-4 mt-2">
            <div className="absolute inset-0">

                {/* Background image different for dark and light mode */}
                <div className="h-full w-full bg-gradient-to-t dark:from-dark-1 from-white via-transparent dark:to-dark-1 dark:via-transparent to-white absolute"></div>
                    <img src="darkbg.jpg" alt="Background" className="dark:block hidden h-full w-full object-cover" />
                    <img src="bg.jpg" alt="Background" className="dark:hidden block h-full w-full object-cover" />

                </div>
            <div className="inset-0 flex flex-row justify-center items-center my-1 xxs:mt-4 xxs:mb-6">

            {/* Panel 1 game centre */}
            <ShortcutsItem 
            text="GAME SCHEDULE" 
            filename="panel1.webp" 
            filename_dark="panel1dark.webp" 
            link="/gamecentre" />
            
            {/* Panel 2 stats */}
            <ShortcutsItem 
            text="PLAYER STATS" 
            filename="panel2.webp" 
            filename_dark="panel2dark.webp" 
            link="gamecentre/stats" 
            last2={true}/>
            
            {/* Panel 3 club finder */}
            <ShortcutsItem text="BUIHA CLUBS" 
            filename="panel3.webp" 
            filename_dark="panel3dark.webp" 
            link="/clubs"
            last={true} />

            {/*/!* Panel 4 info & docs *!/*/}
            {/*<ShortcutsItem text="OUR HISTORY" */}
            {/*filename="panel4.webp" */}
            {/*filename_dark="panel4dark.webp" */}
            {/*link="/history"*/}
            {/*last={true} />*/}

                {/* Panel 4 info & docs */}
                <ShortcutsItem text="ALL STARS INFO"
                               filename="panelias.png"
                               filename_dark="paneliasdark.png"
                               link="/news/1191" />

            </div>
        </div>
    );
}
export default ShortcutsMain;


